import { Button } from "@devhop/ui";
import { DownloadIcon, HelpCircle, PlusIcon } from "lucide-react";

type FormsToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onExport?: () => void;
  onStartTour?: () => void;
};

export function FormsToolbar({
  canManage,
  onCreate,
  onExport,
  onStartTour,
}: FormsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <div className="flex items-center space-x-2">
            <h2 className="font-bold text-2xl tracking-tight">ລາຍການຟອມ</h2>
            {onStartTour && (
              <Button
                variant="ghost"
                size="icon"
                className="size-7 rounded-full"
                onClick={onStartTour}
              >
                <HelpCircle className="size-5" />
              </Button>
            )}
          </div>
          <p className="text-muted-foreground">
            ຈັດການແລະຕິດຕາມຟອມຂອງອົງກອນທົ່ວທຸກພະແນກ.
          </p>
        </div>
        <div className="flex items-center space-x-2">
          {onExport && (
            <Button variant="outline" onClick={onExport}>
              <DownloadIcon className="h-4 w-4" />
              ສົ່ງອອກຂໍ້ມູນ
            </Button>
          )}
          {canManage && (
            <div data-tourid="forms-toolbar">
              <Button onClick={onCreate}>
                <PlusIcon className="h-4 w-4" />
                ສ້າງຟອມໃໝ່
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
